<template>
    <Motion
      :initial="{ opacity: 0, x: 20 }"
      :animate="{ opacity: 1, x: 0 }"
      :transition="{ duration: 0.5, delay: 0.4, type: 'spring' }"
    >
      <div class="bg-gradient-to-br from-white/90 via-white/85 to-white/80  backdrop-blur-sm rounded-xl p-6 md:p-8 shadow-lg border border-gray-100  transform transition-all hover:shadow-xl">
        <div class="max-w-2xl mx-auto px-4">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 rounded-full bg-gradient-to-br from-yellow-400 to-amber-500 flex items-center justify-center mr-4 flex-shrink-0 shadow-md">
              <v-icon color="white" size="24">mdi-information-outline</v-icon>
            </div>
            <div>
              <h2 class="text-2xl font-bold text-slate-800 ">About the Duck Owner</h2>
              <div class="h-1 w-24 bg-gradient-to-r from-yellow-400 to-amber-500 rounded-full mt-1"></div>
            </div>
          </div>
          
          <div class="relative">
            <!-- Decorative elements -->
            <div class="absolute -top-4 -left-4 w-8 h-8 text-yellow-400/30">
              <v-icon size="32">mdi-format-quote-open</v-icon>
            </div>
            <div class="absolute -bottom-4 -right-4 w-8 h-8 text-yellow-400/30">
              <v-icon size="32">mdi-format-quote-close</v-icon>
            </div>
            
            <div class="bg-gradient-to-r from-yellow-50 to-amber-50 p-5 rounded-lg border-l-4 border-yellow-500 mb-8 relative z-10">
              <p class="text-gray-700 italic break-words overflow-hidden leading-relaxed">
                "{{ cruise?.aboutUs || 'We love hiding ducks for others to find! Hope you enjoy this little treasure hunt.' }}"
              </p>
            </div>
          </div>
          
          <div class="flex flex-col md:flex-row items-center md:items-start gap-6">
            <div class="relative">
              <div class="absolute inset-0 bg-gradient-to-br from-yellow-400/20 to-amber-500/20 rounded-lg -rotate-2"></div>
              <div class="absolute inset-0 bg-gradient-to-br from-blue-400/10 to-blue-500/10 rounded-lg rotate-2"></div>
              <img 
                src="/ducksImages/duckIcon.webp" 
                alt="Duck family" 
                class="relative w-28 h-28 object-contain rounded-lg shadow-md flex-shrink-0 p-1 bg-white/80 z-10"
              />
            </div>
            
            <div class="md:ml-2">
              <h3 class="font-semibold text-lg text-slate-800  mb-3 break-words flex items-center">
                <span>From the Duck Family</span>
                <div class="inline-flex ml-2 text-yellow-500 ">
                  <v-icon size="18">mdi-duck</v-icon>
                </div>
              </h3>
              <p class="text-gray-700  break-words leading-relaxed">
                Thank you for participating in our duck hunt! We hope this little surprise brought a smile to your face.
                Don't forget to share your discovery and consider hiding the duck for someone else to find.
              </p>
              <div class="mt-4 flex items-center text-sm text-gray-500 ">
                <v-icon size="16" class="mr-1">mdi-hand-heart</v-icon>
                <span>Made with love by the DuckNSeek team</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Motion>
  </template>
  
  <script setup lang="ts">
  import { Motion } from 'motion-v';
  import { inject } from 'vue';
  
  defineProps({
    cruise: {
      type: Object,
      default: () => inject('cruise', {})
    }
  });
  </script>
  
  <style scoped>
  /* Add a subtle hover effect */
  .bg-gradient-to-br {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .bg-gradient-to-br:hover {
    transform: translateY(-2px);
  }
  
  /* Improve mobile readability */
  @media (max-width: 640px) {
    .break-words {
      word-break: break-word;
    }
    
    h2.text-2xl {
      font-size: 1.25rem; /* Slightly smaller on mobile */
    }
  }
  </style>